import { toast } from 'sonner';

/**
 * 모듈 싱글톤 — useToast가 매 렌더 새 객체를 만들면
 * useCallback/useEffect 의존성으로 들어간 조회 이펙트가 무한 재실행된다.
 */
export const toastApi = {
  success: (content: string, duration?: number) =>
    toast.success(content, { duration: (duration ?? 3) * 1000 }),
  error: (content: string, duration?: number) =>
    toast.error(content, { duration: (duration ?? 5) * 1000 }),
  warning: (content: string, duration?: number) =>
    toast.warning(content, { duration: (duration ?? 4) * 1000 }),
  info: (content: string, duration?: number) =>
    toast.info(content, { duration: (duration ?? 3) * 1000 }),
  loading: async <T,>(
    promise: Promise<T>,
    messages: { loading: string; success: string; error: string },
  ): Promise<T> => {
    toast.promise(promise, {
      loading: messages.loading,
      success: messages.success,
      error: messages.error,
    });
    return promise;
  },
};

export type ToastApi = typeof toastApi;

export const useToast = (): ToastApi => toastApi;

export const handleApiError = (
  error: unknown,
  toastInstance: ToastApi = toastApi,
) => {
  let message = '오류가 발생했습니다.';

  const err = error as {
    response?: { data?: { message?: string } };
    message?: string;
  };

  if (err?.response?.data?.message) {
    message = err.response.data.message;
  } else if (err?.message) {
    message = err.message;
  }

  toastInstance.error(message);
};

export const handleFormError = (
  error: unknown,
  toastInstance: ToastApi = toastApi,
) => {
  const err = error as {
    response?: { data?: { errors?: Record<string, string[]> } };
  };

  if (err?.response?.data?.errors) {
    const errors = err.response.data.errors;
    const firstError = Object.values(errors)[0]?.[0];
    toastInstance.error(firstError || '입력값을 확인해주세요.');
  } else {
    handleApiError(error, toastInstance);
  }
};
